<div class="tab-pane" style="z-index:50;position:relative" role="tabpanel" id="propiedades">
    <fieldset id="agregar_propiedades" class="">
        <div class="step_section">
            <h4 class="form-signin-heading"><strong>Informacion propiedades(<span style="color:red; font-size: 25px">*</span>)</strong>(Ingrese hasta 3 propiedades) </h4>
            <hr>
            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <div>
                        <div class="alert alert-danger" role="alert" id="rol_dir_find_alert" name="rol_dir_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="rol_dir_message"></span>
                        </div>
                        <p>Ingrese Rol o la Direcci&oacute;n (calle y n&uacute;mero) de la propiedad.</p>
                        <div class="form-horizontal">
                            <div class="form-group">
                                <div class="row" style="margin-left: 0px">
                                    <label for="rol" class="col-sm-1" style="padding-top: 20px;">Rol</label>
                                    <div class="col-sm-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Rol" id="rol" name="rol" [formControl]="rol" [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="rol.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-3"></div>
                                    <div class="col-sm-2">
                                        <button mat-raised-button color="primary" id="b_rol" (click)="getPropiedades_rol()">
                                        Buscar Rol 
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        
                                    </button>
                                        <div class="col-sm-3"></div>
                                    </div>
                                </div>

                                <div class="form-group" style="margin-left: 0px">
                                    <div class="row" style="margin-left: 0px">
                                        <label for="PDI_Calle_Nombre" class="col-sm-1" style="padding-top: 20px;">Direcci&oacute;n</label>
                                        <div class="col-sm-2">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Dirección" id="PDI_Calle_Nombre" name="PDI_Calle_Nombre" [formControl]="dir" [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="dir.hasError('required')">
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                        <div class="col-sm-2" style="padding-right: 10px; padding-left: 10px;">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Número" id="PDI_Num_Calle" name="PDI_Num_Calle" [formControl]="num" [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="num.hasError('required')">
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-1"></div>
                                        <div class="col-sm-2" style="padding-left: 10px">
                                            <button mat-raised-button color="primary" id="b_dir" [disabled]="invalidDir" (click)="getPropiedades_dir()">
                                                Buscar Direccion 
                                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!--Detalle de los propietarios-->

                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>ROL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rol}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>Direccion</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.direccion_completa}} </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="getPropiedades_por_rol(row.rol, row.id_direcc)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="deletePropiedades(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>

    </fieldset>
    <!--Material Dialog Modal 1-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Propiedad</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion de la propiedad</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rol">ROL:</label>
                    <div class="col-md-6">
                        <input id="rol" name="rol" type="text" placeholder="ROL" class="form-control input-md" [(ngModel)]="propiedades.rol" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <label class="col-md-4 control-label" for="id_direcc">Id Direccion:</label>
                    <div class="col-md-6">
                        <input id="id_direcc" name="id_direcc" type="text" placeholder="id Direccion" [(ngModel)]="propiedades.id_direcc" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="folio">Folio:</label>
                    <div class="col-md-6">
                        <input id="folio" name="folio" type="text" placeholder="Folio" [(ngModel)]="propiedades.folio" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle">Direcci&oacute;n (Calle):</label>
                    <div class="col-md-6">
                        <input id="calle" name="calle" type="text" placeholder="Calle" [(ngModel)]="propiedades.calle" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle_num">Direcci&oacute;n (Numero):</label>
                    <div class="col-md-6">
                        <input id="calle_num" name="calle_num" type="text" placeholder="Numero" [(ngModel)]="propiedades.calle_num" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direccion_completa">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="direccion_completa" name="direccion_completa" type="text" placeholder="Direccion Completa" [(ngModel)]="propiedades.direccion_completa" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_complemento">Direcci&oacute;n: Complemento</label>
                    <div class="col-md-6">
                        <input id="direc_complemento" name="direc_complemento" type="text" placeholder="Direccion Complemento" [(ngModel)]="propiedades.direc_complemento" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group" *ngIf="nombreMuni!='Lo Barnechea'">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_compl_num">Direcci&oacute;n: Complem. Numero</label>
                    <div class="col-md-6">
                        <input id="direc_compl_num" name="direc_compl_num" type="text" placeholder="Direccion Compl. Numero" [(ngModel)]="propiedades.direc_compl_num" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="loteo">Loteo</label>
                    <div class="col-md-6">
                        <input id="loteo" name="loteo" type="text" placeholder="Loteo" [(ngModel)]="propiedades.loteo" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="manzana">Manzana</label>
                    <div class="col-md-6">
                        <input id="manzana" name="manzana" type="text" placeholder="Manzana" [(ngModel)]="propiedades.manzana" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="plano">Plano</label>
                    <div class="col-md-6">
                        <input id="plano" name="plano" type="text" placeholder="Plano" [(ngModel)]="propiedades.plano" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="ubicacion">Ubicacion</label>
                    <div class="col-md-6">
                        <input id="ubicacion" name="ubicacion" type="text" placeholder="Plano" [(ngModel)]="propiedades.ubicacion" class="form-control input-md" readonly>
                    </div>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedades()">Ingresar Propiedad <i class="fa fa-user-o" aria-hidden="true"></i></button>
        </mat-dialog-actions>
    </ng-template>


    <!--End Material Dialog Modal 1-->


    <!-- Material Dialog Modal 2-->
    <ng-template #modalDirecciones>
        <h2 mat-dialog-title> Seleccionar dirección</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe seleccionar una de las direcciones</strong>
                </div>
                <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
                    <div id="search-field" class="top-div">
                        <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
                    </div>
                </div>
                <ul class="list-group">
                    <li class="list-group-item" *ngFor="let direccion of direcciones | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                        <input type="radio" id="direccionSelec" name="direccionSelect" [value]="direccion" name="modal_dir" [(ngModel)]="temp_dir">
                        <span>{{direccion.direccion_completa}}</span>
                    </li>
                </ul>
                <div style="text-align:center">
                    <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedadesMulti(temp_dir)">Ingresar Propiedad <i class="fa fa-user-o" aria-hidden="true"></i></button>

        </mat-dialog-actions>
    </ng-template>

    <!--End Material Dialog Modal 2-->

    <!--Material Dialog Modal 3-->

    <ng-template #openModalVerPorRol>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Propiedad</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion de la propiedad</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rol">ROL:</label>
                    <div class="col-md-6">
                        <input id="rol" name="rol" type="text" placeholder="ROL" class="form-control input-md" [(ngModel)]="propiedades.rol" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="id_direcc">Id Direccion:</label>
                    <div class="col-md-6">
                        <input id="id_direcc" name="id_direcc" type="text" placeholder="id Direccion" [(ngModel)]="propiedades.id_direcc" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="folio">Folio:</label>
                    <div class="col-md-6">
                        <input id="folio" name="folio" type="text" placeholder="Folio" [(ngModel)]="propiedades.folio" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle">Direcci&oacute;n (Calle):</label>
                    <div class="col-md-6">
                        <input id="calle" name="calle" type="text" placeholder="Calle" [(ngModel)]="propiedades.calle" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle_num">Direcci&oacute;n (Numero):</label>
                    <div class="col-md-6">
                        <input id="calle_num" name="calle_num" type="text" placeholder="Numero" [(ngModel)]="propiedades.calle_num" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direccion_completa">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="direccion_completa" name="direccion_completa" type="text" placeholder="Direccion Completa" [(ngModel)]="propiedades.direccion_completa" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_complemento">Direcci&oacute;n: Complemento</label>
                    <div class="col-md-6">
                        <input id="direc_complemento" name="direc_complemento" type="text" placeholder="Direccion Complemento" [(ngModel)]="propiedades.direc_complemento" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group" *ngIf="nombreMuni!='Lo Barnechea'">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_compl_num">Direcci&oacute;n: Complem. Numero</label>
                    <div class="col-md-6">
                        <input id="direc_compl_num" name="direc_compl_num" type="text" placeholder="Direccion Compl. Numero" [(ngModel)]="propiedades.direc_compl_num" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="loteo">Loteo</label>
                    <div class="col-md-6">
                        <input id="loteo" name="loteo" type="text" placeholder="Loteo" [(ngModel)]="propiedades.loteo" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="manzana">Manzana</label>
                    <div class="col-md-6">
                        <input id="manzana" name="manzana" type="text" placeholder="Manzana" [(ngModel)]="propiedades.manzana" class="form-control input-md" readonly>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="plano">Plano</label>
                    <div class="col-md-6">
                        <input id="plano" name="plano" type="text" placeholder="Plano" [(ngModel)]="propiedades.plano" class="form-control input-md" readonly>
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="ubicacion">Ubicacion</label>
                    <div class="col-md-6">
                        <input id="ubicacion" name="ubicacion" type="text" placeholder="Plano" [(ngModel)]="propiedades.ubicacion" class="form-control input-md" readonly>
                    </div>

                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Salir</button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog Modal 3-->
</div>
<div class="separator"></div>